module.exports = __webpack_public_path__ + "static/img/chanta (18).8827a35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chanta/chanta (18).jpg
// module id = OhZV
// module chunks = 0